module.exports = __webpack_public_path__ + "assets/img/list_0.f6e66ccd.svg";